import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

export const BodyWrapper = styled.div`
  background-color: ${theme.colors.darkBlues[5]};
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
`;
